export function convertValueToArray(obj) {
  const result = {};
  for (let key in obj) {
    const value = obj[key];
    if (value === null || value === undefined) {
      result[key] = [""];
    } else if (Array.isArray(value)) {
      result[key] = value;
    } else {
      result[key] = [value];
    }
  }
  return result;
}
